export interface TimeBalanceAccount {
  id: string;
  personId: string;
  balanceType: string;
  unit: string;
  currentBalanceHours: number;
  createdAt: string;
  updatedAt: string;
}
